import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=e56bf13a"
import script from "./SuccessBox.vue?vue&type=script&lang=js"
export * from "./SuccessBox.vue?vue&type=script&lang=js"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&id=e56bf13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports